import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { usePopupState, bindTrigger, bindMenu } from 'material-ui-popup-state/hooks';

import { MoreMenuItem } from '@/pages/document/components/DocumentMoreButton/components/CascadingMenu';
import CascadingMenuContext from '@/pages/document/components/DocumentMoreButton/components/CascadingMenuContext';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';

import MoreVertIcon from '@mui/icons-material/MoreVert';

interface MoreMenuOption {
  id: string | number;
  isHidden?: boolean;
}

interface Props {
  options: MoreMenuOption[];
}

const DocumentMoreButtonDropdown: React.FC<Props> = ({ options }) => {
  const popupState = usePopupState({ variant: 'popover', popupId: 'MoreButton' });

  const contextValue = useMemo(
    () => ({
      rootPopupState: popupState,
      parentPopupState: popupState,
    }),
    [popupState],
  );

  const list = options.filter((option) => !option.isHidden);

  return (
    <>
      <Button color="primary" variant="text" startIcon={<MoreVertIcon />} {...bindTrigger(popupState)}>
        <FormattedMessage id="document.show.btns.more" defaultMessage="More" />
      </Button>
      <Menu
        autoFocus
        transformOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
        slotProps={{ paper: { sx: { mt: -1 } }, list: { component: 'div' } }}
        {...bindMenu(popupState)}
      >
        <CascadingMenuContext.Provider value={contextValue}>
          {list.map((option) => (
            <MoreMenuItem option={option} key={option.id} />
          ))}
        </CascadingMenuContext.Provider>
      </Menu>
    </>
  );
};

export default DocumentMoreButtonDropdown;
